import styled from "styled-components";

export const Wrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: 0.2fr 1fr;
	height: 100%;
	width: 100%;
	@media (max-width: 768px) {
		grid-template-rows: 0.1fr 2fr;
	}
`;

export const InfoWrapper = styled.div`
	align-items: center;
	display: flex;
	justify-content: center;
	width: 100%;
	height: 100%;

	@media (max-width: 768px) {
		margin-top: 0;
		align-items: flex-start;
	}
`;
